// src/utils/cards.js
export function digitsOnly(s = "") {
  return String(s).replace(/\D+/g, "");
}

// Brand detection 
export function detectCardBrand(num) {
  const s = digitsOnly(num);
  if (/^4\d{12,18}$/.test(s)) return "visa";
  if (/^(5[1-5]\d{14}|2(2[2-9]\d|[3-6]\d{2}|7[01]\d|720)\d{12})$/.test(s)) return "mastercard";
  if (/^3[47]\d{13}$/.test(s)) return "amex";
  if (/^6(?:011|5\d{2})\d{12}$/.test(s)) return "discover";
  return "card"; 
}

export function maxLengthForBrand(brand) {
  return brand === "amex" ? 15 : 16; // good enough for mock
}

export function cvcLengthForBrand(brand) {
  return brand === "amex" ? 4 : 3;
}

// Format the number with spaces as the user types
export function formatCardNumber(raw) {
  const clean = digitsOnly(raw);
  const brand = detectCardBrand(clean);

  const max = maxLengthForBrand(brand);
  const clipped = clean.slice(0, max);

  if (brand === "amex") {
    // 4-6-5 grouping
    const g1 = clipped.slice(0, 4);
    const g2 = clipped.slice(4, 10);
    const g3 = clipped.slice(10, 15);
    return { formatted: [g1, g2, g3].filter(Boolean).join(" "), brand };
  } else {
    // groups of 4
    return {
      formatted: clipped.replace(/(\d{4})(?=\d)/g, "$1 ").trim(),
      brand
    };
  }
}
